import { useLazyQuery } from '@apollo/client'
import { Button, useMediaQuery, useTheme } from '@material-ui/core'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import GenerateAPIKeyModal from '../../components/GenerateAPIKeyModal'
import SectionTitle from '../../components/SectionTitle'
import ChannelAPIKeysList from '../../components/UserAPIKeysList'
import { CHANNEL_API_KEYS } from '../../graphql/channelAPIKeys'
import { getRoleFromStorage } from '../../helpers/userData'
import { getTranslate } from '../../localization'
import channelPagesRoleManagement from '../../staticRoleManagement/channelPagesRoleManagement'
import { ChannelAPIKeys } from '../../types/channelAPIKeys'
import useStyles from './styles/index.styles'

interface ChannelApiKeyProps {
  cachedLevels: (
    | {
        label: string
        link: string
      }
    | {
        label: string
        link?: undefined
      }
  )[]
}

const ChannelAPIkeys: React.FC<ChannelApiKeyProps> = ({ cachedLevels }) => {
  const theme = useTheme()
  const classes = useStyles()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const [generateModalIsOpen, setgenerateModalIsOpen] = useState(false)
  const [getAPIKeys, { loading, data, refetch }] = useLazyQuery<{
    channelAPIKeys: ChannelAPIKeys[]
  }>(CHANNEL_API_KEYS)
  const params = useParams<{ id: string }>()
  useEffect(() => {
    getAPIKeys({ variables: { channelId: params.id } })
  }, [data])

  const hasAccessToModifyChannelApiKeys = channelPagesRoleManagement
    .find((item) => item.route === '/channels/:id/:channelCode/:page')
    ?.tabs?.find((routeTabItem) => routeTabItem.params.page === 'api-keys')
    ?.rolesListWithWriteAccess?.includes(getRoleFromStorage())

  return (
    <div className={classes.root}>
      <GenerateAPIKeyModal
        isOpen={generateModalIsOpen}
        onClose={() => setgenerateModalIsOpen(false)}
        cachedLevels={cachedLevels}
        reloadData={refetch}
      />
      <div className={classes.header}>
        <SectionTitle title="API Keys" />
        <Button
          disabled={!hasAccessToModifyChannelApiKeys}
          variant="contained"
          color="primary"
          onClick={() => setgenerateModalIsOpen(true)}>
          {getTranslate(`Generate${isSmallScreen ? '' : ' New API Key'}`)}
        </Button>
      </div>
      <ChannelAPIKeysList
        hasAccessToModifyChannelApiKeys={hasAccessToModifyChannelApiKeys}
        refetch={refetch}
        data={data?.channelAPIKeys || []}
        loading={loading}
      />
    </div>
  )
}

export default ChannelAPIkeys
